import { ReleaseNote } from '../interface/releaseNotes';

export const getReleaseNotesForLanguage = (item: ReleaseNote, language: string) => {
  switch (language) {
    case 'fi':
      return item?.releaseNotes?.fi;
    case 'sv':
      return item?.releaseNotes?.se;
    default:
      return item?.releaseNotes?.en;
  }
};
